// extracted by mini-css-extract-plugin
module.exports = {"container":"tabButtons_container__3xqNs","button":"tabButtons_button__2dcA9","active":"tabButtons_active__2vSi7"};